export const NB_CHAT_COMMON_FILTER = 'newbuilding_chat_common_filter';
export const NB_CONSULTANT_TRIGGERING_MESSAGE = 'newbuilding-triggering-message';
export const RENTER_FORM_EXPERIMENT = 'renter_form_experiment';
export const NB_LAYOUT_LISTING = 'newbuilding_layout_listing_inside_jk_desktop';

export const BX_HYBRID_SEARCH_EXPERIMENT = 'vx_desktop_bx_863_hybrid_listing';

export const NEWBUILDING_MONTHLY_PAYMENT = 'newbuilding_monthly_payment_desktop';
export const AUD_DESKTOP_BX842_SEARCH_STRING_LISTING = 'aud_desktop_bx842_search_string_listing';

export const COMMON_CPD_LANDING_EXPERIMENT = 'newbuilding_common_cpd_page';

export const EXPERIMENTS: string[] = [
  'newbuilding_consultant',
  NB_CHAT_COMMON_FILTER,
  NB_CONSULTANT_TRIGGERING_MESSAGE,
  RENTER_FORM_EXPERIMENT,
  NB_LAYOUT_LISTING,
  BX_HYBRID_SEARCH_EXPERIMENT,
  NEWBUILDING_MONTHLY_PAYMENT,
  AUD_DESKTOP_BX842_SEARCH_STRING_LISTING,
  COMMON_CPD_LANDING_EXPERIMENT,
];
